module.exports = __webpack_public_path__ + "static/img/bg2.e534f88b.png";